export function stringIsNullOrEmpty(str: string) {
	return str == null || str.trim() === "";
}
